let lastScrollTop = 0;

(function () {
	// HEADER
	const mainHeader = document.getElementById('header');
	const mainLogo = mainHeader.querySelector('.js-scroll-logo img');
	const logoImages = mainLogo ? [mainLogo.getAttribute('src'), mainLogo.dataset.scroll] : null;
	const topContentExists = document.querySelectorAll('.top-content img').length > 0 || document.querySelectorAll('.top-content video').length > 0 ;
	const isHomePage = document.getElementById('home') !== null;
	const keepScroll = !isHomePage && document.querySelectorAll('.scrollInternal').length > 0;

	window.onload = function () {
		convertBtn();

		scrollW(mainHeader, logoImages, topContentExists ? 0 : -1);
	   if(keepScroll) {
			scrollW(mainHeader, logoImages, -1);
		}

		window.addEventListener('scroll', () => {
			const startFrom = keepScroll ? -1 : (topContentExists ? 0 : -1);
        	scrollW(mainHeader, logoImages, startFrom);
		});

		// ANIMATE FORM LABELS ON FOCUS
		const fieldSelectors = '.form-module__field input, .form-module__field select, .form-module__field textarea, .field.input input';
		document.querySelectorAll(fieldSelectors).forEach((field) => {
			// CHECK INITIAL VALUE
			if (field.value !== '') {
				field.parentElement.classList.add('move');
			}

			// FOCUS EVENT
			field.addEventListener('focus', () => field.parentElement.classList.add('move'));
		});
	};

	// TOGGLE PRIMARY SUBMENUS ON CLICK
	document.querySelectorAll('.privary-navigation__item:has(ul)').forEach((li) => {
		let prevShowingSubmenu = null;
		const itemLink = li.querySelector('a');

		itemLink.addEventListener('click', (e) => {
			if ((document.body.classList.contains('_gtpl_body-nav-inline') && window.innerWidth < 1090) || !document.body.classList.contains('_gtpl_body-nav-inline')) {
				e.preventDefault();

				prevShowingSubmenu = document.querySelector('.privary-navigation__item.show-submenu');
				if (prevShowingSubmenu && prevShowingSubmenu !== li) prevShowingSubmenu.classList.remove('show-submenu');
				li.classList.toggle('show-submenu');
			}
		});
	});

	// ACCORDION TOGGLE
	document.querySelectorAll('.accordion-block').forEach((accordion) => {
		accordion.querySelectorAll('.accordion-block_item-head').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.accordion-block_item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('active');
				});
				itemHead.parentNode.classList.toggle('active');
			});
		});
	});

	//insert hours into intro
	if (document.querySelectorAll('.js-insert-hours').length > 0) {
		if (document.querySelector('.js-hours')) {
			document.querySelector('.js-hours').append(document.querySelectorAll('.js-insert-hours')[0]);
			document.querySelector('.intro-content').classList.add('with-hours');
		}
	}

	//swiper
	let defaultSettings = {
		loop: true,
		speed: 1200,
		effect: 'fade',
		fadeEffect: { crossFade: true },
		autoplay: { delay: 5000, disableOnInteraction: false },
		init: false,
		loopAdditionalSlides: 1,
		resistanceRatio: 0.
	};

	let allSwipper = [];

	document.querySelectorAll('.js-swiper').forEach((element, i) => {
		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaultSettings;

		let combinedOps = Object.assign({}, defaultSettings, swiperConfig);

		element.setAttribute(`data-swiper-${i}`, '');

		let swiper = new Swiper(`[data-swiper-${i}]`, combinedOps);

		/**
		 * Update custom dots 'active' state when slide changes
		 */
		/* if (element.querySelectorAll('[data-swiper-goto]').length > 0) {
			swiper.on('init, slideChange', ({ realIndex }) => {
				element.querySelectorAll('[data-swiper-goto]').forEach((item) => {
					item.classList.toggle('js-swiper_active', parseInt(item.dataset.swiperGoto) === realIndex);
				});
			});
		} */

		swiper.on('init, slideChange', ({ realIndex }) => {
			updateLinkedGotos(realIndex, element);
		});

		swiper.init();

		if (combinedOps.rtl) {
			swiper.changeLanguageDirection('rtl');
		}

		allSwipper[i] = swiper;
	});

	function updateLinkedGotos(index, slider) {
		const gotosBySlider = [...document.querySelectorAll('[data-swiper-goto]')].filter((btn) => {
			const btnSlider = btn.dataset.swiperTarget ? document.querySelector(btn.dataset.swiperTarget) : btn.closest('.js-swiper');
			return btnSlider === slider;
		});

		gotosBySlider.forEach((item) => {
			item.classList.toggle('js-swiper_active', parseInt(item.dataset.swiperGoto) === index);
		});
	}

	/**
	 * Add custom dots click event
	 */
	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.js-swiper');

		item.addEventListener('click', () => {
			if (slider.swiper.params.loop) {
				slider.swiper.slideToLoop(target);
			} else {
				slider.swiper.slideTo(target);
			}

			item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	document.querySelectorAll('[data-swiper-control]').forEach((mainSlider) => {
		const selectorsLinked = mainSlider.dataset.swiperControl ? JSON.parse(mainSlider.dataset.swiperControl) : [];
		if (selectorsLinked.length < 1) {
			return false;
		}

		const slidersLinked = selectorsLinked
			.map((selector) => {
				return [...document.querySelectorAll(selector)].map((el) => el.swiper);
			})
			.flat();
		mainSlider.swiper.controller.control = slidersLinked;
	});
})();

/**
 * Set header classes on scroll
 * @param {HTMLElement} header
 * @param {number} startFrom
 */
function scrollW(header, logoImages, startFrom = 0) {
	const scrollTop = document.documentElement.scrollTop;
	header.classList.toggle('scroll', scrollTop > startFrom);
	header.classList.toggle('down', scrollTop > startFrom && scrollTop > lastScrollTop);
	header.classList.toggle('up', scrollTop > startFrom && scrollTop < lastScrollTop);

	if (logoImages) {
		header.querySelector('.js-scroll-logo img').setAttribute('src', scrollTop > startFrom ? logoImages[1] : logoImages[0]);
	}

	lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // CHECK MOBILE NEGATIVE SCROLLING
}

function convertBtn() {
	if (document.getElementsByClassName('btn').length > 0) {
		let ALL_BTNS = document.querySelectorAll('.btn');
		ALL_BTNS.forEach((btn) => {
			// if (btn.getAttribute('type') !== 'submit') {
			let INNER_TEXT = btn.innerHTML;
			btn.innerHTML = '<span>' + INNER_TEXT + '</span><span class="deco"></span>';
			// }
		});
	}
	if (document.getElementsByClassName('signup-btn').length > 0) {
		document.querySelectorAll('.signup-btn').forEach((btn) => {
			let INNER_TEXT = btn.innerHTML;
			btn.innerHTML = INNER_TEXT + '<span class="deco"></span>';
		});
	}

	// CLASS FROM PARENT
	document.querySelectorAll('[data-btn_class]').forEach((context) => {
		const btnClass = context.dataset.btn_class.trim();
		if (btnClass) { 
			context.querySelectorAll('.btn, .signup-btn').forEach((btn) => btn.classList.add(btnClass));
		}
	});
}
